import { render, staticRenderFns } from "./home-office-coordinator.vue?vue&type=template&id=08e8c168"
import script from "./home-office-coordinator.vue?vue&type=script&lang=js"
export * from "./home-office-coordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports